import { render, staticRenderFns } from "./ProductVideoShelf.vue?vue&type=template&id=2bd467ba&scoped=true"
import script from "./ProductVideoShelf.vue?vue&type=script&lang=js"
export * from "./ProductVideoShelf.vue?vue&type=script&lang=js"
import style0 from "./ProductVideoShelf.vue?vue&type=style&index=0&id=2bd467ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd467ba",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ProductVideoPreview: require('/app/components/ProductVideoPreview.vue').default})
